import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'
import { useRouter } from 'next/router'
import { useContext, useState, useEffect, MouseEvent } from 'react'

import { colors, icons, mobileScreen, show } from '../utils'
import { H4 } from './H4'
import { User, NookEvent } from '../types'
import { H5 } from './H5'
import EventItemList from './Discover/EventItemList'
import { H3 } from './H3'
import { EventsContext, UserContext } from '../context'
import { P } from './P'
import { Section as SECTION } from './Section'
import { LoadMoreButton } from './LoadMoreButton'

// Section.
const Section = styled(SECTION)`
  width: 100%;

  .takeALookHeader {
    margin-top: 80px;
    width: 100%;
    text-align: left;
  }

  .takeALookEvents {
    width: 100%;
    margin-bottom: 70px;

    & section {
      & .content {
        padding: 0;
      }
    }
  }

  .EventItemList {
    margin-top: 25px;
    ${mobileScreen(
      css`
        margin-top: 18px;
      `,
    )}
  }

  .takeALookContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .takeALookButton {
    display: flex;
    justify-content: center;
  }

  .exploreAllContainer {
    display: flex;
    cursor: pointer;
    color: ${colors.purple};
    border: none;
    background-color: ${colors.white};
  }

  .callout {
    color: ${colors.purple};
    margin-right: 5px;
  }

  .arrowDown {
    width: 18px;
    height: 18px;
  }

  .takeALookSection {
    margin-bottom: 70px;
  }
`

// Props.
interface Props {
  header: string
  className?: string
  page: string
  events: NookEvent[]
  showExploreAllCta?: boolean
  numberOfEventToShow?: number
  showMoreButton?: boolean
}

// Explore All.
export const ExploreAll: React.FC<Props> = ({
  header,
  className,
  page,
  events,
  showExploreAllCta = true,
  numberOfEventToShow = 4,
  showMoreButton = false,
}) => {
  const { t } = useTranslation('common')

  // Props.
  // const  = props
  // const theShowExploreAll =  (showExploreAll == true || show)

  // Global State
  const router = useRouter()

  // Local State
  const [showExploreAll, setShowExploreAll] = useState<boolean>(false)

  // Funcs
  const onExploreAll = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    router.push('/discover').then(() => window.scrollTo(0, 0))
  }

  // ..
  return (
    <Section className={`takeALookSection ${className}`}>
      <div className="takeALookContainer">
        <H3 className="takeALookHeader">{header}</H3>
        <div className="takeALookEvents">
          <EventItemList
            eventsToShow={events}
            firstEventIndex={0}
            numberOfEventToShow={showExploreAll ? 1000 : numberOfEventToShow}
            page={page}
          />
        </div>
        {show(showExploreAllCta == true) && (
          <>
            <div className="exploreAllContainer" onClick={onExploreAll}>
              <P className="callout">{t(`Explore all`, `Explore all`)}</P>
              <img className="arrowDown" src={icons.arrowRight}></img>
            </div>
          </>
        )}
      </div>
      {show(showMoreButton && !showExploreAll) && (
        <div
          className="takeALookButton"
          onClick={() => setShowExploreAll(true)}>
          <LoadMoreButton>{t('Load more', 'Load more')}</LoadMoreButton>
        </div>
      )}
    </Section>
  )
}
